import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-100/95 backdrop-blur-md shadow-lg shadow-black/20'
          : 'bg-transparent'
      }`}
    >
      <div className="container-site">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <span className="text-2xl font-heading font-bold text-primary-500 group-hover:text-primary-400 transition-colors">
              6080
            </span>
            <span className="text-lg font-heading text-foreground-800 hidden sm:inline">
              影院
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 text-sm rounded-md transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/'
                  ? 'text-primary-500 bg-primary-500/10'
                  : 'text-foreground-600 hover:text-foreground-800 hover:bg-background-200'
              }`}
            >
              首页
            </Link>
            {categories.slice(0, 6).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 text-sm rounded-md transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'text-primary-500 bg-primary-500/10'
                    : 'text-foreground-600 hover:text-foreground-800 hover:bg-background-200'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 text-sm rounded-md transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/about'
                  ? 'text-primary-500 bg-primary-500/10'
                  : 'text-foreground-600 hover:text-foreground-800 hover:bg-background-200'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 hover:text-foreground-900 cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-100/98 backdrop-blur-md border-t border-background-200">
          <div className="container-site py-4 flex flex-col gap-1">
            <Link
              to="/"
              className={`px-4 py-3 text-sm rounded-md transition-colors cursor-pointer ${
                location.pathname === '/'
                  ? 'text-primary-500 bg-primary-500/10'
                  : 'text-foreground-600 hover:text-foreground-800'
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-3 text-sm rounded-md transition-colors cursor-pointer ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'text-primary-500 bg-primary-500/10'
                    : 'text-foreground-600 hover:text-foreground-800'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-3 text-sm rounded-md transition-colors cursor-pointer ${
                location.pathname === '/about'
                  ? 'text-primary-500 bg-primary-500/10'
                  : 'text-foreground-600 hover:text-foreground-800'
              }`}
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}